import { useRef, useEffect } from "react";
import TextWithLink from "./Variants/TextWithLink";
import TextWithLinkAndIcon from "./Variants/TextWithLinkAndIcon";
import MediaCard from "./Variants/MediaCard";
import VerticalToHorizontalCard from "./Variants/VerticalToHorizontalCard";
import CardWrapper from "./utils/CardWrapper";
import { CardVariantsEnum } from "./interface";
import { BaseCardProps } from "./interface";
import { VTH_CARD_LAYOUTS } from "./Variants/VerticalToHorizontalCard/constants";
import { MultiMediaCard } from "./Variants/MultiMediaCard";

const Card = (props: BaseCardProps) => {
    const {
        variant,
        onClick,
        renderAsButton,
        featureAttribution,
        item,
        columns,
    } = props;

    const cardRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (props.focus && cardRef.current) {
            cardRef.current.focus();
        }
    }, [props.focus]);

    const CardProps = {
        cardRef,
        onClick,
        renderAsButton,
        featureAttribution,
        item,
        variant,
    };

    switch (variant) {
        case CardVariantsEnum.TEXT_WITH_LINK:
            return (
                <CardWrapper {...CardProps}>
                    <TextWithLink {...props} />
                </CardWrapper>
            );
        case CardVariantsEnum.TEXT_WITH_LINK_AND_ICON:
            return (
                <CardWrapper {...CardProps}>
                    <TextWithLinkAndIcon {...props} />
                </CardWrapper>
            );
        case CardVariantsEnum.MEDIA:
            return (
                <CardWrapper {...CardProps}>
                    <MediaCard {...props} />
                </CardWrapper>
            );
        case CardVariantsEnum.MULTI_MEDIA:
            return (
                <CardWrapper {...CardProps}>
                    <MultiMediaCard {...props} />
                </CardWrapper>
            );
        case CardVariantsEnum.VERTICAL_TO_HORIZONTAL:
            return (
                <VerticalToHorizontalCard
                    cardRef={cardRef}
                    vthBreakpoints={
                        columns === 1
                            ? VTH_CARD_LAYOUTS.HORIZONAL_ONE_COLUMN
                            : VTH_CARD_LAYOUTS.HORIZONAL_TWO_COLUMN
                    }
                    {...props}
                />
            );
        default:
            return null;
    }
};

export default Card;
